import { 
    CHECK_STOCK_REQUEST, 
    CHECK_STOCK_SUCCESS, 
    CHECK_STOCK_FAILURE } 
from "../types/stockTypes";

const initialState = {
  stockLoading: false,
  stockData: null,
  stockstockError: null,
};

const stockReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_STOCK_REQUEST:
      return {
        ...state,
        stockLoading: true,
        stockError: null,
      };
    case CHECK_STOCK_SUCCESS:
      return {
        ...state,
        stockLoading: false,
        stockData: action.payload, // Response from the API
        stockError: null,
      };
    case CHECK_STOCK_FAILURE:
      return {
        ...state,
        stockLoading: false,
        stockError: action.payload, // stockError message
      };
    default:
      return state;
  }
};

export default stockReducer;